'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var WantlistEntry = require('../wantlist').Entry;

var CID = require('cids');

var assert = require('assert');

module.exports =
/*#__PURE__*/
function () {
  function BitswapMessageEntry(cid, priority, cancel) {
    _classCallCheck(this, BitswapMessageEntry);

    assert(CID.isCID(cid), 'needs valid cid');
    this.entry = new WantlistEntry(cid, priority);
    this.cancel = Boolean(cancel);
  }

  _createClass(BitswapMessageEntry, [{
    key: "equals",
    value: function equals(other) {
      return this.cancel === other.cancel && this.entry.equals(other.entry);
    }
  }, {
    key: "cid",
    get: function get() {
      return this.entry.cid;
    },
    set: function set(cid) {
      this.entry.cid = cid;
    }
  }, {
    key: "priority",
    get: function get() {
      return this.entry.priority;
    },
    set: function set(val) {
      this.entry.priority = val;
    }
  }, {
    key: Symbol.toStringTag,
    get: function get() {
      var cidStr = this.cid.toBaseEncodedString();
      return "BitswapMessageEntry ".concat(cidStr, " <cancel: ").concat(this.cancel, ", priority: ").concat(this.priority, ">");
    }
  }]);

  return BitswapMessageEntry;
}();